import { ConnectionError, WebFsError } from '#common/types';
export class SendFailedError extends ConnectionError {
}
export class RequestTimeoutError extends ConnectionError {
    constructor(id) {
        super(`Request with id: ${id.toString()} has timed out.`);
    }
}
export class InvalidMessageError extends WebFsError {
}
export class ErrorResponseError extends WebFsError {
    code;
    constructor(code, message) {
        super(`Received error response. Error code: ${code}, error message: ${message}`);
        this.code = code;
    }
}
